import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";
import { fetchRentalPropertyAgeStatus, RentalPropertyAgePoint } from "src/site/estat";
import { ChartSpec, debounce, isSp, renderChart } from "src/site/recharts";

// Site::PrefectureArea::RentalPropertyAgeStatus::Component の Stimulus コントローラ。
// landIeul: components/PrefectureDetail/RentalPropertyAgeStatus/index.tsx の BarChart。

class SitePrefectureAreaRentalPropertyAgeStatusController extends Controller<HTMLElement> {
  static targets = ["graph", "modeAgeInTotal", "modeAgeInWooden", "modeAgeInNotWooden"];
  static values = { areaCode: String };

  declare readonly graphTarget: HTMLElement;
  declare readonly modeAgeInTotalTarget: HTMLElement;
  declare readonly modeAgeInWoodenTarget: HTMLElement;
  declare readonly modeAgeInNotWoodenTarget: HTMLElement;
  declare readonly areaCodeValue: string;

  private graphData: RentalPropertyAgePoint[] = [];
  private onResize?: () => void;

  connect(): void {
    this.onResize = debounce(() => this.draw());
    window.addEventListener("resize", this.onResize);
    void this.load();
  }

  disconnect(): void {
    if (this.onResize) window.removeEventListener("resize", this.onResize);
  }

  private async load(): Promise<void> {
    const result = await fetchRentalPropertyAgeStatus(this.areaCodeValue);
    if (!result) return;
    this.graphData = result.graphData;
    this.modeAgeInTotalTarget.textContent = result.modeAgeInTotal;
    this.modeAgeInWoodenTarget.textContent = result.modeAgeInWooden;
    this.modeAgeInNotWoodenTarget.textContent = result.modeAgeInNotWooden;
    this.draw();
  }

  private draw(): void {
    if (this.graphData.length === 0) return;
    renderChart(this.graphTarget, this.spec());
  }

  private spec(): ChartSpec {
    const sp = isSp();
    const tickFontSize = sp ? "10px" : "11px";
    const strokeWidth = sp ? 2 : 3;
    return {
      kind: "bar",
      data: this.graphData as unknown as ChartSpec["data"],
      xKey: "age",
      xPadding: { left: 20, right: 20 },
      xTickFontSize: tickFontSize,
      yTickFontSize: tickFontSize,
      yUnit: "戸",
      yLocaleString: true,
      legendWrapperStyle: {
        "font-size": sp ? "10px" : "15px",
        "margin-left": "20px",
        "line-height": "40px",
      },
      series: [
        { key: "totalRentalHouse", name: "全体", stroke: "#FF367F", fill: "#FF367F", strokeWidth, unit: "戸" },
        { key: "woodenRentalHouse", name: "木造", stroke: "#66CDAA", fill: "#66CDAA", strokeWidth, unit: "戸" },
        { key: "notWoodenRentalHouse", name: "非木造", stroke: "#2C7CFF", fill: "#2C7CFF", strokeWidth, unit: "戸" },
      ],
      containerStyle: "width:100%;height:100%;min-width:0",
    };
  }
}

application.register(
  "site--prefecture-area--rental-property-age-status",
  SitePrefectureAreaRentalPropertyAgeStatusController,
);
